import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import styled from "styled-components";
import { StyledDisclaimersWrapper } from "../../containers/App/styles";
import messages from "./messages";

const FooterGrid = styled(Grid)`
  font-family: "Lato";

  hr {
    margin-bottom: 40px;
    border: none;
    border-top:2px solid rgba(155,155,155,0.39)
  }

  label {
    font-weight: bold;
  }
`;

const FooterDisclaimers = styled(StyledDisclaimersWrapper)`
margin: 0px !important;
  p {
    &:last-child {
      margin-bottom: 60px;
    }
  }
`;

const HeaderDescription = () => {
  return (
    <React.Fragment>
      <FooterGrid item xs={11} sm={10} md={8} lg={9} xl={7}>
        <hr />
        <label>
          <FormattedMessage {...messages.title} />
        </label>
      </FooterGrid>
      <FooterDisclaimers item xs={11} sm={10} md={8} lg={9} xl={7}>
        <FormattedHTMLMessage {...messages.description} />
      </FooterDisclaimers>
    </React.Fragment>
  );
};

HeaderDescription.propTypes = {
  currentStep: PropTypes.string
};

export default HeaderDescription;
